module.exports = __webpack_public_path__ + "static/media/carrorama-video-numeros.574cc3fe.webp";